import { useActionCable } from '@/shared/composables/useActionCable.ts'
import { MENTORS_MATCHING_EXPLANATION_CHANNEL } from '@/shared/data/actionCableChannels.js'
import { useDebugger } from '@/shared/composables/useDebugger.js'
import { onMounted } from 'vue'

export const useMatchingExplanation = ({
  onReceived,
}: {
  onReceived: (data: unknown) => void
}) => {
  const { $debug } = useDebugger()

  const { subscribeChannel } = useActionCable({
    channelName: MENTORS_MATCHING_EXPLANATION_CHANNEL,
    onConnected: () => {
      $debug(`[AC Channel: ${MENTORS_MATCHING_EXPLANATION_CHANNEL}] connected`)
    },
    onReceived: (data) => {
      onReceived(data)
    },
  })

  onMounted(() => {
    subscribeChannel()
  })
}
